import { Info } from 'lucide-react';
import Section from './ui/Section.jsx';
import Eyebrow from './ui/Eyebrow.jsx';
import Pill from './ui/Pill.jsx';
import Reveal from './ui/Reveal.jsx';
import { pricingItems } from '../data/pricing.js';

export default function Pricing() {
  return (
    <Section id="tarieven" label="05 Tarieven">
      <Reveal style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 48 }}>
        <Eyebrow>Tarieven</Eyebrow>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 400,
            fontSize: 'clamp(36px, 4vw, 56px)',
            lineHeight: 1.1,
            letterSpacing: '-0.01em',
            color: 'var(--ink)',
            margin: '8px 0 0',
          }}
        >
          Transparante <span style={{ fontStyle: 'italic' }}>tarieven.</span>
        </h2>
      </Reveal>

      <div
        className="section-grid-2"
        style={{
          display: 'grid',
          gridTemplateColumns: '1.1fr 0.9fr',
          gap: 24,
          alignItems: 'stretch',
        }}
      >
        {pricingItems.map((it, i) => (
          <Reveal
            key={it.title}
            delay={120 * i}
            className="pricing-card"
            style={{
              background: it.featured ? 'var(--cream-2)' : 'transparent',
              boxShadow: it.featured ? 'var(--shadow-card)' : 'inset 0 0 0 1px var(--line)',
              borderRadius: 'var(--radius-md)',
              padding: '36px 36px',
              display: 'flex',
              flexDirection: 'column',
              gap: 18,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'space-between',
                gap: 16,
              }}
            >
              <span
                style={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 400,
                  fontSize: 28,
                  color: 'var(--ink)',
                  letterSpacing: '-0.005em',
                }}
              >
                {it.title}
              </span>
              {it.featured && <Pill tone="blue">Meest gekozen</Pill>}
            </div>

            <div style={{ display: 'flex', alignItems: 'baseline', gap: 10 }}>
              <span
                className="pricing-price"
                style={{
                  fontFamily: 'var(--font-display)',
                  fontWeight: 400,
                  fontSize: 64,
                  lineHeight: 1,
                  color: 'var(--ink)',
                  letterSpacing: '-0.02em',
                }}
              >
                {it.price}
              </span>
              <span
                style={{ fontFamily: 'var(--font-body)', fontSize: 14, color: 'var(--ink-3)' }}
              >
                {it.unit}
              </span>
            </div>

            <p
              style={{
                fontFamily: 'var(--font-body)',
                fontSize: 15,
                lineHeight: 1.7,
                color: 'var(--ink-2)',
                margin: 0,
              }}
            >
              {it.body}
            </p>
          </Reveal>
        ))}
      </div>

      {/* Reimbursement note */}
      <Reveal
        delay={80}
        style={{
          marginTop: 40,
          background: 'var(--cream)',
          boxShadow: 'inset 0 0 0 1px var(--line)',
          borderRadius: 'var(--radius-md)',
          padding: '24px 28px',
          display: 'flex',
          gap: 20,
          alignItems: 'flex-start',
        }}
      >
        <Info size={22} strokeWidth={1.5} color="var(--blue-deep)" style={{ flexShrink: 0, marginTop: 2 }} />
        <div>
          <div
            style={{
              fontFamily: 'var(--font-body)',
              fontWeight: 700,
              fontSize: 15,
              color: 'var(--ink)',
              marginBottom: 4,
            }}
          >
            Vergoeding
          </div>
          <p
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: 14,
              lineHeight: 1.65,
              color: 'var(--ink-2)',
              margin: 0,
              maxWidth: '70ch',
            }}
          >
            Mijn praktijk heeft geen contracten met zorgverzekeraars. Het is van belang om van te
            voren goed uit te zoeken welk percentage van de kosten door jouw verzekeraar wordt
            vergoed — je bent hiervoor zelf verantwoordelijk.
          </p>
        </div>
      </Reveal>
    </Section>
  );
}
